var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnnouncementPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.642,
    height: 19.642,
    viewBox: "0 0 25.642 22.642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Play_Green",
    "data-name": "Play Green",
    d: "M13.321,2A11.321,11.321,0,1,0,24.642,13.321,11.325,11.325,0,0,0,13.321,2ZM11.057,18.416V8.227l6.793,5.095Z",
    transform: "translate(-2 -2)",
    fill: "#61bb46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnouncementPlay);
export default __webpack_public_path__ + "static/media/icon-announcement-play.b62c251f339915411c9cf76d9f3c0189.svg";
export { ForwardRef as ReactComponent };